import VueRouter from "vue-router";
// 导航路由
export const constantRoutes = [
  {
    path: "/",
    name: "index",
    meta: {
      title: "首页",
      layoutClass: ["bg-white"],
      menuKey: "web_home",
    },
    component: () => import("@/pages/home/index.vue"),
  },
  {
    path: "/news",
    name: "news",
    meta: {
      title: "产业资讯",
      menuKey: "web_info",
    },
    redirect: { name: "news.complex" },
    component: () => import("@/pages/news/index.vue"),
    /**
     * 当前栏目共用(default)一个列表页/详情页
     * 定制栏目需自行开发(文件名称建议path命名)
     * 例如：{
              path: "commentary",
              name: "news.commentary",
              meta: {
                title: "行情解说",
                code: "700005",
              },
              component: () => import("@/pages/news/commentary/index.vue"),
            },
       路由为/news/complex，可以直接使用编辑器的快捷键快速进入对应的路由模版
     */
    children: [
      {
        path: "complex",
        name: "news.complex",
        meta: {
          title: "国内要闻",
          columnlayout: "list",
          code: "700001",
          menuKey: "info_comprehensive",
        },
        component: () => import("@/pages/news/default/index.vue"),
      },
      {
        path: "complex/:id",
        name: "news.complex.detail",
        hidden: true,
        meta: {
          title: "详情",
          columnlayout: "detail",
          breadcrumb: [{ name: "news.complex", title: "国内要闻" }],
          menuKey: "info_comprehensive",
        },
        component: () => import("@/pages/news/default/detail.vue"),
      },
      {
        path: "newssn",
        name: "news.newssn",
        meta: {
          title: "省内快讯",
          code: "700007",
          menuKey: "info_industry_paper",
        },
        component: () => import("@/pages/news/default/index.vue"),
      },
      {
        path: "newssn/:id",
        name: "news.newssn.detail",
        hidden: true,
        meta: {
          title: "详情",
          columnlayout: "detail",
          breadcrumb: [{ name: "news.newssn", title: "省内快讯" }],
          menuKey: "info_industry_paper",
        },
        component: () => import("@/pages/news/default/detail.vue"),
      },
      {
        path: "newsqx",
        name: "news.newsqx",
        meta: {
          title: "外省动态",
          code: "700008",
          menuKey: "info_industry_paper",
        },
        component: () => import("@/pages/news/default/index.vue"),
      },
      {
        path: "newsqx/:id",
        name: "news.newsqx.detail",
        hidden: true,
        meta: {
          title: "详情",
          columnlayout: "detail",
          breadcrumb: [{ name: "news.newsqx", title: "外省动态" }],
          menuKey: "info_industry_paper",
        },
        component: () => import("@/pages/news/default/detail.vue"),
      },

      {
        path: "industry",
        name: "news.industry",
        meta: {
          title: "产业快讯",
          code: "700002",
          menuKey: "info_industry_news",
        },
        component: () => import("@/pages/news/default/index.vue"),
      },
      {
        path: "industry/:id",
        name: "news.industry.detail",
        hidden: true,
        meta: {
          title: "详情",
          columnlayout: "detail",
          breadcrumb: [{ name: "news.industry", title: "产业快讯" }],
          menuKey: "info_industry_news",
        },
        component: () => import("@/pages/news/default/detail.vue"),
      },

      {
        path: "variety",
        name: "news.variety",
        meta: {
          title: "价格指数",
          code: "700003",
          menuKey: "info_variety",
        },
        component: () => import("@/pages/news/default/index.vue"),
      },
      {
        path: "variety/:id",
        name: "news.variety.detail",
        hidden: true,
        meta: {
          title: "详情",
          columnlayout: "detail",
          breadcrumb: [{ name: "news.variety", title: "价格指数" }],
          menuKey: "info_variety",
        },
        component: () => import("@/pages/news/default/detail.vue"),
      },

      {
        path: "policy",
        name: "news.policy",
        meta: {
          title: "政策文件",
          code: "700004",
          menuKey: "info_policy",
        },
        component: () => import("@/pages/news/default/index.vue"),
      },
      {
        path: "policy/:id",
        name: "news.policy.detail",
        hidden: true,
        meta: {
          title: "详情",
          columnlayout: "detail",
          breadcrumb: [{ name: "news.policy", title: "政策文件" }],
          menuKey: "info_policy",
        },
        component: () => import("@/pages/news/default/detail.vue"),
      },
      {
        path: "commentary",
        name: "news.commentary",
        meta: {
          title: "行情解说",
          code: "700005",
          menuKey: "info_industry_paper",
        },
        component: () => import("@/pages/news/commentary/index.vue"),
      },
      {
        path: "commentary/:id",
        name: "news.commentary.detail",
        hidden: true,
        meta: {
          title: "详情",
          columnlayout: "detail",
          breadcrumb: [{ name: "news.commentary", title: "行情解说" }],
          menuKey: "info_industry_paper",
        },
        component: () => import("@/pages/news/default/detail.vue"),
      },
    ],
  },
  {
    path: "/trade",
    name: "trade",
    meta: {
      title: "交易大厅",
      menuKey: "web_transaction",
    },
    redirect: { name: "trade.price" },
    component: () => import("@/pages/trade/index.vue"),
    children: [
      {
        path: "price",
        name: "trade.price",
        meta: {
          title: "市场价格",
          menuKey: "transaction_price",
        },
        component: () => import("@/pages/trade/price/index.vue"),
      },
      {
        path: "price/:id",
        name: "trade.price.detail",
        hidden: true,
        meta: {
          title: "详情",
          columnlayout: "fair",
          breadcrumb: [{ name: "trade.price", title: "市场价格" }],
          menuKey: "transaction_price",
        },
        component: () => import("@/pages/trade/price/detail.vue"),
      },
      {
        path: "origin",
        name: "trade.origin",
        meta: {
          title: "产地价格",
          menuKey: "transaction_origin",
        },
        component: () => import("@/pages/trade/origin/index.vue"),
      },
      {
        path: "marchant",
        name: "trade.marchant",
        meta: {
          title: "商户列表",
          menuKey: "transaction_marchant",
        },
        component: () => import("@/pages/trade/marchant/index.vue"),
      },
      {
        path: "supply",
        name: "trade.supply",
        meta: {
          title: "药材供应",
          menuKey: "transaction_supply",
        },
        component: () => import("@/pages/trade/supply/index.vue"),
      },
      {
        path: "buy",
        name: "trade.buy",
        meta: {
          title: "药材求购",
          menuKey: "transaction_purchase",
        },
        component: () => import("@/pages/trade/buy/index.vue"),
      },
      {
        path: "tender",
        name: "trade.tender",
        meta: {
          title: "招标采购",
          menuKey: "transaction_bidding",
        },
        component: () => import("@/pages/trade/tender/index.vue"),
      },
      {
        path: "tender/:id",
        name: "trade.tender.detail",
        hidden: true,
        meta: {
          title: "详情",
          columnlayout: "detail",
          breadcrumb: [{ name: "trade.tender", title: "招标采购" }],
          menuKey: "transaction_bidding",
        },
        component: () => import("@/pages/trade/tender/detail.vue"),
      },
      // {
      //   path: "auction",
      //   name: "trade.auction",
      //   meta: {
      //     title: "拍卖大厅",
      //     menuKey: "web_transaction",
      //   },
      //   component: () => import("@/pages/trade/auction/index.vue"),
      // },
    ],
  },
  {
    path: "/service",
    name: "service",
    meta: {
      title: "服务大厅",
      menuKey: "web_service",
    },
    redirect: { name: "service.expert" },
    component: () => import("@/pages/service/index.vue"),
    /**
     * 当前栏目部分共用(default)一个列表页/详情页
     * 定制栏目可用预留文件(path命名)
     */
    children: [
      {
        path: "expert",
        name: "service.expert",
        meta: {
          title: "专家服务",
          menuKey: "service_expert",
        },
        redirect: { name: "service.expert.people" },
        component: () => import("@/pages/service/expert/index.vue"),
        children: [
          {
            path: "people",
            name: "service.expert.people",
            meta: {
              title: "行业专家",
              menuKey: "expert_doctor",
            },
            component: () => import("@/pages/service/expert/people/index.vue"),
          },
          {
            path: "plant",
            name: "service.expert.plant",
            meta: {
              title: "种植技术",
              code: "700006",
              menuKey: "expert_plant",
            },
            component: () => import("@/pages/service/expert/plant/index.vue"),
          },
          {
            path: "plant/:id",
            name: "service.expert.plant.detail",
            hidden: true,
            meta: {
              title: "详情",
              columnlayout: "detail",
              breadcrumb: [{ name: "service.expert.plant", title: "种植技术" }],
              menuKey: "expert_plant",
            },
            component: () => import("@/pages/service/expert/plant/detail.vue"),
          },
          {
            path: "train",
            name: "service.expert.train",
            meta: {
              title: "培训课堂",
              menuKey: "expert_classroom",
            },
            component: () => import("@/pages/service/expert/train/index.vue"),
          },
          {
            path: "train/:id",
            name: "service.expert.train.detail",
            hidden: true,
            meta: {
              title: "详情",
              columnlayout: "detail",
              breadcrumb: [{ name: "service.expert.train", title: "培训课堂" }],
              menuKey: "expert_classroom",
            },
            component: () => import("@/pages/service/expert/train/detail.vue"),
          },
        ],
      },
      {
        path: "detect",
        name: "service.detect",
        meta: {
          title: "检测服务",
          code: "800002",
          menuKey: "service_inspect",
        },
        component: () => import("@/pages/service/detect/index.vue"),
      },
      {
        path: "detect/:id",
        name: "service.detect.detail",
        hidden: true,
        meta: {
          title: "详情",
          columnlayout: "detail",
          breadcrumb: [{ name: "service.detect", title: "检测服务" }],
          menuKey: "service_inspect",
        },
        component: () => import("@/pages/service/default/detail.vue"),
      },
      {
        path: "finance",
        name: "service.finance",
        meta: {
          title: "金融服务",
          code: "800003",
          menuKey: "service_funds",
        },
        component: () => import("@/pages/service/default/index.vue"),
      },
      {
        path: "finance/:id",
        name: "service.finance.detail",
        hidden: true,
        meta: {
          title: "详情",
          columnlayout: "detail",
          breadcrumb: [{ name: "service.finance", title: "金融服务" }],
          menuKey: "service_funds",
        },
        component: () => import("@/pages/service/default/detail.vue"),
      },
      {
        path: "logistic",
        name: "service.logistic",
        meta: {
          title: "仓储物流",
          code: "800004",
          menuKey: "service_warehouse",
        },
        component: () => import("@/pages/service/default/index.vue"),
      },
      {
        path: "logistic/:id",
        name: "service.logistic.detail",
        hidden: true,
        meta: {
          title: "详情",
          columnlayout: "detail",
          breadcrumb: [{ name: "service.logistic", title: "仓储物流" }],
          menuKey: "service_warehouse",
        },
        component: () => import("@/pages/service/default/detail.vue"),
      },
      {
        path: "resource",
        name: "service.resource",
        meta: {
          title: "农资农机",
          code: "800005",
          menuKey: "service_farming",
        },
        component: () => import("@/pages/service/default/index.vue"),
      },
      {
        path: "resource/:id",
        name: "service.resource.detail",
        hidden: true,
        meta: {
          title: "详情",
          columnlayout: "detail",
          breadcrumb: [{ name: "service.resource", title: "农资农机" }],
          menuKey: "service_farming",
        },
        component: () => import("@/pages/service/default/detail.vue"),
      },
    ],
  },
  {
    path: "/project",
    name: "project",
    meta: {
      title: "项目申报",
      menuKey: "web_project",
    },
    redirect: { name: "project.policy" },
    component: () => import("@/pages/project/index.vue"),
    children: [
      {
        path: "policy",
        name: "project.policy",
        meta: {
          title: "政策列表",
          code: "800001",
          menuKey: "project_policy",
        },
        component: () => import("@/pages/project/policy/index.vue"),
      },
      {
        path: "policy/:id",
        name: "project.policy.detail",
        hidden: true,
        meta: {
          title: "详情",
          columnlayout: "detail",
          breadcrumb: [{ name: "project.policy", title: "政策列表" }],
          menuKey: "project_policy",
        },
        component: () => import("@/pages/project/policy/detail.vue"),
      },
      {
        path: "publicity",
        name: "project.publicity",
        meta: {
          title: "项目公示",
          code: "800006",
          menuKey: "project_show",
        },
        component: () => import("@/pages/project/publicity/index.vue"),
      },
      {
        path: "publicity/:id",
        name: "project.publicity.detail",
        hidden: true,
        meta: {
          title: "详情",
          columnlayout: "detail",
          breadcrumb: [{ name: "project.publicity", title: "项目公示" }],
          menuKey: "project_show",
        },
        component: () => import("@/pages/project/publicity/detail.vue"),
      },
    ],
  },
  {
    path: "/industry",
    name: "industry",
    meta: {
      title: "产业研究",
      layoutClass: ["bg-gradient"],
      menuKey: "web_industry_paper",
    },
    redirect: { name: "industry.report" },
    component: () => import("@/pages/industry/index.vue"),
    children: [
      {
        path: "learning",
        name: "industry.learning",
        meta: {
          title: "学术研究",
          layoutClass: ["bg-gradient"],
          menuKey: "web_industry_paper",
        },
        component: () => import("@/pages/industry/learning/index.vue"),
      },
      {
        path: "learning/:id",
        name: "industry.learning.detail",
        hidden: true,
        meta: {
          title: "详情",
          columnlayout: "detail",
          breadcrumb: [{ name: "industry.learning", title: "学术研究" }],
          menuKey: "web_industry_paper",
        },
        component: () => import("@/pages/industry/learning/detail.vue"),
      },
      {
        path: "report",
        name: "industry.report",
        meta: {
          title: "产业报告",
          layoutClass: ["bg-gradient"],
          menuKey: "web_industry_paper",
        },
        component: () => import("@/pages/industry/report/index.vue"),
      },
      {
        path: "report/:id",
        name: "industry.report.detail",
        hidden: true,
        meta: {
          title: "详情",
          columnlayout: "detail",
          breadcrumb: [{ name: "industry.report", title: "产业报告" }],
          menuKey: "web_industry_paper",
        },
        component: () => import("@/pages/industry/report/detail.vue"),
      },
    ],
  },
  {
    path: "/topten",
    name: "topten",
    meta: {
      title: "十大晋药",
      layoutClass: ["bg-gradient"],
      menuKey: "web_herbal",
    },
    component: () => import("@/pages/topten/index.vue"),
    children: [
      {
        path: ":id",
        name: "topten.detail",
        hidden: true,
        meta: {
          title: "十大晋药",
          layoutClass: ["bg-gradient"],
          menuKey: "web_herbal",
        },
        component: () => import("@/pages/topten/detail.vue"),
      },
    ],
  },
  {
    path: "/featured-districts",
    name: "FeaturedDistricts",
    meta: {
      title: "特色区县",
      layoutClass: ["bg-gradient"],
    },
    component: () => import("@/pages/featuredDistricts/index.vue"),
  },
  {
    path: "/data",
    name: "data",
    meta: {
      title: `数据库`,
    },
    redirect: { name: "data.produce" },
    component: () => import("@/pages/data/index.vue"),
    children: [
      {
        path: "/remote-sensing",
        name: "data.remoteSensing",
        meta: {
          title: "遥感监测",
        },
        redirect: { name: "remoteSensing" },
      },
      {
        path: "/report",
        name: "data.report",
        meta: {
          title: "产业报告",
          menuKey: "web_industry_paper",
        },
        redirect: { name: "industry.report" },
        // component: () => import("@/pages/report/index.vue"),
      },
      {
        path: "produce",
        name: "data.produce",
        meta: {
          title: "生产环节",
          columnlayout: "fair",
        },
        redirect: { name: "data.produce.cost" },
        component: () => import("@/pages/data/produce/index.vue"),
        children: [
          {
            path: "cost",
            name: "data.produce.cost",
            meta: {
              title: "种植成本",
            },
            component: () => import("@/pages/data/produce/cost/index.vue"),
          },
          {
            path: "yield",
            name: "data.produce.yield",
            meta: {
              title: "产量数据",
            },
            component: () => import("@/pages/data/produce/yield/index.vue"),
          },
          {
            path: "cooperative",
            name: "data.produce.cooperative",
            meta: {
              title: "生产合作社",
            },
            component: () =>
              import("@/pages/data/produce/cooperative/index.vue"),
          },
          {
            path: "period",
            name: "data.produce.period",
            meta: {
              title: "产新期数据",
            },
            component: () => import("@/pages/data/produce/period/index.vue"),
          },
          {
            path: "dryingRate",
            name: "data.produce.dryingRate",
            meta: {
              title: "药材折干率",
            },
            component: () =>
              import("@/pages/data/produce/dryingRate/index.vue"),
          },
        ],
      },
      {
        path: "circulation",
        name: "data.circulation",
        meta: {
          title: "流通环节",
          columnlayout: "fair",
        },
        redirect: { name: "data.circulation.pharmacopoeia" },
        component: () => import("@/pages/data/circulation/index.vue"),
        children: [
          {
            path: "historicalPrices",
            name: "data.circulation.historicalPrices",
            meta: {
              title: "市场历史价格",
            },
            redirect: {
              name: "trade.price.detail",
              query: { name: "黄芪", market: 1 },
              params: {
                id: 1,
              },
            },
            component: () =>
              import("@/pages/data/circulation/historicalPrices/index.vue"),
          },
          {
            path: "pharmacopoeia",
            name: "data.circulation.pharmacopoeia",
            meta: {
              title: "药典标准",
            },
            component: () =>
              import("@/pages/data/circulation/pharmacopoeia/index.vue"),
          },
        ],
      },
      {
        path: "consume",
        name: "data.consume",
        meta: {
          title: "消耗环节",
          columnlayout: "fair",
        },
        redirect: { name: "data.consume.enterprise" },
        component: () => import("@/pages/data/consume/index.vue"),
        children: [
          {
            path: "enterprise",
            name: "data.consume.enterprise",
            meta: {
              title: "成药企业",
            },
            component: () =>
              import("@/pages/data/consume/enterprise/index.vue"),
          },
          {
            path: "drug",
            name: "data.consume.drug",
            meta: {
              title: "成药产品",
            },
            component: () => import("@/pages/data/consume/drug/index.vue"),
          },
        ],
      },
      {
        path: "consumption",
        name: "data.consumption",
        meta: {
          title: "消费环节",
          columnlayout: "fair",
        },
        redirect: { name: "data.consumption.prescription" },
        component: () => import("@/pages/data/consumption/index.vue"),
        children: [
          {
            path: "prescription",
            name: "data.consumption.prescription",
            meta: {
              title: "药典名方",
            },
            component: () =>
              import("@/pages/data/consumption/prescription/index.vue"),
          },
          {
            path: "efficacy",
            name: "data.consumption.efficacy",
            meta: {
              title: "药材功效",
            },
            component: () =>
              import("@/pages/data/consumption/efficacy/index.vue"),
          },
          {
            path: "distinguish",
            name: "data.consumption.distinguish",
            meta: {
              title: "真伪鉴别",
            },
            component: () =>
              import("@/pages/data/consumption/distinguish/index.vue"),
          },
          {
            path: "statistics",
            name: "data.consumption.statistics",
            meta: {
              title: "统计局数据",
            },
            component: () =>
              import("@/pages/data/consumption/statistics/index.vue"),
          },
        ],
      },
      {
        path: "standard",
        name: "data.standard",
        meta: {
          title: "标准库",
          columnlayout: "fair",
        },
        component: () => import("@/pages/data/standard/index.vue"),
      },
      {
        path: "standard/:id",
        name: "data.standard.detail",
        hidden: true,
        meta: {
          title: "详情",
          columnlayout: "detail",
          breadcrumb: [{ name: "data.standard", title: "标准库" }],
        },
        component: () => import("@/pages/data/standard/detail.vue"),
      },
    ],
  },
  // TODO 临时添加，后续删除
  {
    path: "/yaobo/#",
    name: "yaobo",
    meta: {
      title: "会展",
      layout: "blank",
      isLink: true,
    },
    component: () => import("@/pages/yaobo.vue"),
  },
  {
    path: "/auth/login",
    name: "auth.login",
    hidden: true,
    meta: {
      title: "欢迎登录",
      layout: "auth",
    },
    component: () => import("@/pages/auth/login.vue"),
  },
  {
    path: "/auth/signup",
    name: "auth.signup",
    hidden: true,
    meta: {
      title: "欢迎注册",
      layout: "auth",
    },
    component: () => import("@/pages/auth/signup.vue"),
  },
  {
    path: "/auth/change-password",
    name: "auth.changePassword",
    hidden: true,
    meta: {
      title: "修改密码",
      layout: "auth",
    },
    component: () => import("@/pages/auth/changePassword.vue"),
  },
  {
    path: "/auth/service-agreement",
    name: "auth.serviceAgreement",
    hidden: true,
    meta: {
      title: "服务协议",
      layout: "blank",
    },
    component: () => import("@/pages/auth/serviceAgreement.vue"),
  },
  {
    path: "/auth/privacy-policy",
    name: "auth.privacyPolicy",
    hidden: true,
    meta: {
      title: "隐私政策",
      layout: "blank",
    },
    component: () => import("@/pages/auth/privacyPolicy.vue"),
  },
  {
    path: "/remote-sensing",
    name: "remoteSensing",
    hidden: true,
    meta: {
      title: "遥感监测",
      layout: "blank",
    },
    component: () => import("@/pages/data/remoteSensing/index.vue"),
  },
  {
    path: "/remote-sensing/detail",
    name: "remoteSensing.detail",
    hidden: true,
    meta: {
      title: "遥感监测",
      layout: "blank",
    },
    component: () => import("@/pages/data/remoteSensing/detail.vue"),
  },
  {
    path: "/search",
    name: "search",
    hidden: true,
    meta: {
      title: "搜索结果",
    },
    component: () => import("@/pages/search"),
  },
  {
    path: "/announcement",
    name: "announcement",
    hidden: true,
    meta: {
      title: "通知公告",
    },
    component: () => import("@/pages/announcement/index.vue"),
  },
  {
    path: "/announcement/:id",
    name: "announcement.detail",
    hidden: true,
    meta: {
      title: "公告详情",
      breadcrumb: [{ name: "announcement", title: "通知公告" }],
    },
    component: () => import("@/pages/announcement/detail.vue"),
  },
  {
    path: "/404",
    name: "404",
    hidden: true,
    meta: {
      title: "404",
      layout: "blank",
    },
    component: () => import("@/pages/notFind.vue"),
  },
  {
    path: "/403",
    name: "403",
    hidden: true,
    meta: {
      title: "404",
      layout: "blank",
    },
    component: () => import("@/pages/noPermission.vue"),
  },
  {
    path: "*",
    hidden: true,
    meta: {
      title: "404",
    },
    redirect: { name: "404" },
  },
];

// TODO asyncRoutes
export const asyncRoutes = [];

// 每个路由可以指定一个布局组件添加到元数据对象上
export function addLayoutToRoute(route, parentLayout = "default") {
  route.meta.layout = route?.meta.layout || parentLayout;

  if (route.children) {
    route.children = route.children.map((childRoute) =>
      addLayoutToRoute(childRoute, route.meta.layout)
    );
  }
  return route;
}

const routes = [...constantRoutes].map((route) => addLayoutToRoute(route));

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to) {
    if (to.hash) {
      return {
        selector: to.hash,
        behavior: "smooth",
      };
    }
    // return {
    //   x: 0,
    //   y: 104,
    //   behavior: "smooth",
    // };
  },
});

export default router;
